<template>
  <v-navigation-drawer
    :mini-variant="mini"
    permanent
    app
    color="#f7f8fa"
  >
    <v-layout
      fill-height
      column
      justify-space-between
    >
      <!-- top position -->
      <div>
        <!-- Logo -->
        <v-list-item class="px-2">
          <v-list-item-avatar
            v-if="mini"
            width="42"
            height="42"
            tile
          >
            <v-img
              src="@/assets/everli-avatar.png"
              @click.stop="mini = !mini"
            />
          </v-list-item-avatar>

          <v-list-item-title v-if="!mini">
            <v-img
              id="bigLogo"
              width="120"
              height="42"
              src="@/assets/everli-logo.png"
              @click.stop="mini = !mini"
            />
          </v-list-item-title>
        </v-list-item>

        <!-- main menu -->
        <v-list flat>
          <v-list-item-group v-model="activeItem">
            <v-list-item to="/orders">
              <v-list-item-icon>
                <v-icon>mdi-cart</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ $t('mainMenu.orders') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <v-divider />

        <!-- logout -->
        <v-list flat>
          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-exit-to-app</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ $t('mainMenu.logout') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>

      <div
        v-if="!mini"
        id="bottomPanel"
        class="align-end"
      >
        <v-select
          v-model="currentLanguage"
          :items="languages"
          :label="$t('mainMenu.language')"
          solo
          dense
          append-icon="mdi-translate"
        />
        <v-row id="infoBar">
          <v-col class="py-0">
            Version: {{ version }}
          </v-col>
          <v-col
            v-if="isDeveloper"
            class="py-0"
          >
            Debug:
            <v-btn
              text
              x-small
              :color="inDebugMode ? 'primary' : 'gray'"
              @click="switchDebugMode"
            >
              {{ inDebugMode ? 'ON' : 'OFF' }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import packageJson from '@/../package'

export default {
  data () {
    return {
      activeItem: 1,
      languages: ['en', 'it', 'pl'],
      version: packageJson.version,
      drawer: true,
      mini: true
    }
  },

  computed: {
    ...mapGetters('auth', [
      'getUserLanguage',
      'isDeveloper'
    ]),
    ...mapGetters('system', [
      'inDebugMode',
    ]),
    currentLanguage: {
      get () {
        return this.getUserLanguage
      },
      set (selectedLanguage) {
        this.setLocale(selectedLanguage)
      }
    }
  },

  methods: {
    ...mapActions('system', [
      'toggleDebugMode'
    ]),

    logout () {
      this.$store.dispatch('auth/logout')
        .finally(() => this.$router.push({ path: '/login' }))
    },
    switchDebugMode () {
      this.toggleDebugMode()
      window.location.reload()
    }
  }
}
</script>

<style lang="scss">
.v-application--is-ltr .v-list-item__avatar:first-child {
  margin-right: 5px!important;
}
</style>

<style lang="scss" scoped>
#bigLogo {
  margin-top: 8px;
  margin-bottom: 8px;
}

#bottomPanel {
  padding: 20px;
}

#infoBar {
  font-size: 14px;
  text-align: center;
}
</style>
